<template>
  <div class="h-full">
    <HMTMapFrame />
  </div>
</template>

<script>
  import HMTMapFrame from '@/shared/components/MapFrame';

  export default {
    name: 'Map',
    components: {
      HMTMapFrame
    }
  };
</script>
